<template>
  <v-card class="pb-2 profile">
    <v-row align="start" justify="center">
      <v-avatar class="profile-image" size="200">
        <v-img
          :lazy-src="image.thumbnail"
          :position="image.position"
          :src="image.url"
        >
          <template v-slot:placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-row>
          </template>
        </v-img>
      </v-avatar>
    </v-row>
    <v-card-title
      class="d-flex justify-center"
    >{{name}}</v-card-title>
    <v-card-text class="profile-description">
      <slot name="description"></slot>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  VAvatar,
  VCard,
  VCardText,
  VCardTitle,
  VImg,
  VProgressCircular,
  VRow,
} from 'vuetify/lib'

export default {
  components: {
    VAvatar,
    VCard,
    VCardText,
    VCardTitle,
    VImg,
    VProgressCircular,
    VRow,
  },
  props: {
    description: String,
    height: {
      default: undefined,
      type: String,
    },
    image: Object,
    name: String,
  }
}
</script>

<style lang="scss" scoped>
.profile {

  height: calc(100% - 120px);
  margin-top: 120px !important;

  .profile-description {
    font-size: 13px !important;
  }

  .profile-image {
    border: 10px solid white;
    margin-top: -130px;
  }
}
</style>
